import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment.demo';

@Component({
  selector: 'app-contact-card',
  templateUrl: './contact-card.component.html',
  styleUrls: ['./contact-card.component.scss'],
})
export class ContactCardComponent implements OnInit {
  @Input() contactData: any;
  mailText: any;
  portalUrl = environment.portalURL;
  user: any;
  peopleLink: any;
  userEmpId: any;
  teamsLink: any;
  envelopeTooltip = "Outlook Email";
  teamsTooltip = "Microsoft Teams";
  peoplePageTooltip = "People Page";
  constructor() { }

  ngOnInit(): void { }


  sendMail(empId: any) {
    this.mailText =
      `mailto:` +
      empId +
      `?subject=Industry X Developer Hub : Connect Email` +
      `&body=Hi,` +
      "%0D%0A%0D%0A" +
      `I am using the IX developer Hub portal(` +
      this.portalUrl +
      `). I found your reference from the IX developer Hub page, and I am reaching out for the following: ` +
      "%0D%0A%0D%0A";
    window.location.href = this.mailText;
  }

  navigateToPeoplePage(empId: any) {
    this.user = empId.slice(0, empId.indexOf("@")).trim();
    this.peopleLink = "https://people.accenture.com/People/user/" + this.user;
    window.open(this.peopleLink, "_blank");
  }
  teamsNavigate(empId: any) {
    this.teamsLink =
      "https://teams.microsoft.com/l/chat/0/0?users=" + empId;
    window.open(this.teamsLink, "_blank");
  }
}
